// ============================================================================
// Pie del Sidebar: versiones de la aplicación (mismo patrón que front_autohub,
// `app/layout/Sidebar/SidebarVersion.jsx`).
//
//   - Frontend (arriba): leída de `package.json` en build (import estático,
//     vía `shared/config/appVersion`). Siempre disponible.
//   - Backend  (abajo):  consultada al endpoint público `GET /version` de
//     seguridad_backend. Si la petición falla, la línea del backend NO se
//     muestra (degradación silenciosa) para no ensuciar el pie ni romper el
//     render.
//
// Sólo se renderiza con el sidebar expandido (`isOpen`); colapsado no hay
// ancho útil para el texto, igual que el resto de etiquetas del menú.
// ============================================================================
import { useEffect, useState } from "react";

import { getBackendVersion } from "../../../shared/api/sistema";
import { FRONT_VERSION } from "../../../shared/config/appVersion";

interface SidebarVersionProps {
  isOpen: boolean;
}

export const SidebarVersion = ({ isOpen }: SidebarVersionProps) => {
  const [backVersion, setBackVersion] = useState<string | null>(null);

  useEffect(() => {
    let activo = true;
    getBackendVersion().then((v) => {
      if (activo) setBackVersion(v);
    });
    return () => {
      activo = false;
    };
  }, []);

  if (!isOpen) return null;

  const titulo = backVersion
    ? `Frontend ${FRONT_VERSION} · Backend ${backVersion}`
    : `Frontend ${FRONT_VERSION}`;

  return (
    <div className="sidebar__version" title={titulo}>
      <span className="sidebar__version-label">Versión:</span>
      <span className="sidebar__version-values">
        <span className="sidebar__version-line">{FRONT_VERSION}</span>
        {backVersion && (
          <span className="sidebar__version-line">{backVersion}</span>
        )}
      </span>
    </div>
  );
};
